<template>
  <div class="auth-page page">
    <router-view />
  </div>
</template>
<script lang="js">
export default {
  name: "AuthModule"
}
</script>
